export interface CancelData {
    item: string
    number: number
    charge: number
    ccsht_id?: number[]
    stdrv_id?: number[]
    equrv_id?: number[]
}
export interface ObjectToCancelDataProps {
    item: string
    number: number | string
    charge: number | string
    ccsht_id_list?: string
    stdrv_id_list?: string
    equrv_id_list?: string
}
export const ObjectToCancelData = (obj: ObjectToCancelDataProps): CancelData => {
    return {
        item: obj.item,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
        ccsht_id: (typeof obj.ccsht_id_list === "string" && obj.ccsht_id_list.length > 0) ? obj.ccsht_id_list.split(",").map(id => parseInt(id)) : undefined,
        stdrv_id: (typeof obj.stdrv_id_list === "string" && obj.stdrv_id_list.length > 0) ? obj.stdrv_id_list.split(",").map(id => parseInt(id)) : undefined,
        equrv_id: (typeof obj.equrv_id_list === "string" && obj.equrv_id_list.length > 0) ? obj.equrv_id_list.split(",").map(id => parseInt(id)) : undefined,
    }
}